/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const BoltIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M14.47 2.09a.71.71 0 0 1 .339.812l-1.881 6.955h6.864a.7.7 0 0 1 .65.43.72.72 0 0 1-.133.772l-9.917 10.714a.706.706 0 0 1-1.171-.211.72.72 0 0 1-.03-.466l1.882-6.954H4.208a.7.7 0 0 1-.65-.43.72.72 0 0 1 .133-.772l9.917-10.713a.706.706 0 0 1 .862-.137" clipRule="evenodd" /></svg>;
};
export default BoltIcon;